export enum PaymentMethod {
  RAZORPAY = 'razorpay',
  RAZORPAY_SUBSCRIPTION = 'razorpay_subscription',
  BANK_TRANSFER = 'bank_transfer',
  CASH = 'cash',
  UPI = 'upi',
  PAY_LATER = 'pay_later',
}

/** Payment methods supported by the master Create Order screen. */
export const MASTER_ORDER_PAYMENT_METHODS = [
  PaymentMethod.RAZORPAY,
  PaymentMethod.RAZORPAY_SUBSCRIPTION,
  PaymentMethod.UPI,
  PaymentMethod.BANK_TRANSFER,
  PaymentMethod.CASH,
  PaymentMethod.PAY_LATER,
] as const;

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  [PaymentMethod.RAZORPAY]: 'Razorpay',
  [PaymentMethod.RAZORPAY_SUBSCRIPTION]: 'Razorpay subscription',
  [PaymentMethod.UPI]: 'UPI',
  [PaymentMethod.BANK_TRANSFER]: 'Bank transfer',
  [PaymentMethod.CASH]: 'Cash',
  [PaymentMethod.PAY_LATER]: 'Pay later',
};

export function paymentMethodLabel(method: PaymentMethod | string): string {
  return PAYMENT_METHOD_LABELS[method as PaymentMethod] || String(method);
}

export function isRazorpayPaymentMethod(method: PaymentMethod | string | null | undefined): boolean {
  return method === PaymentMethod.RAZORPAY || method === PaymentMethod.RAZORPAY_SUBSCRIPTION;
}
